import React from 'react';

// Damage code checklist grid. Each row: checkbox + optional inline note field.
const DamageGrid = ({ codes, selected, notes, onToggle, onNote, testid }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 sm:gap-x-6 gap-y-2" data-testid={testid}>
    {codes.map(([code, label]) => {
      const isOn = selected.includes(code);
      return (
        <div key={code} className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-2 group">
          <label className="flex items-center gap-2 cursor-pointer flex-shrink-0 sm:w-44">
            <input
              type="checkbox"
              checked={isOn}
              onChange={() => onToggle(code)}
              className="accent-teal-500 w-4 h-4 cursor-pointer"
              data-testid={`${testid}-${code}`}
            />
            <span className={`text-sm ${isOn ? 'text-slate-100' : 'text-slate-400'}`}>
              <span className="font-mono text-teal-300 text-xs mr-1.5">{code}</span>
              {label}
            </span>
          </label>
          {isOn && (
            <input
              value={notes[code] || ''}
              onChange={(e) => onNote(code, e.target.value)}
              placeholder="optional note…"
              className="flex-1 bg-slate-900/60 border border-white/10 rounded px-2 py-1 text-xs text-slate-100 focus:outline-none focus:border-teal-400"
              data-testid={`${testid}-note-${code}`}
            />
          )}
        </div>
      );
    })}
  </div>
);

export default DamageGrid;
